<template>
  <div class="ranking-container">
    <div class="ranking-header">
      <div class="ranking-title">本月客户交易额排行</div>
    </div>
    <div class="ranking-body">
      <div class="list-wrap dz-scroll-y">
        <div class="list" v-for="(item, index) in List" :key="index">
          <p>
            <span class="ranking-num">{{ index + 1 }}</span>
            <span class="ranking-name">{{ item.Name }}</span>
            <span class="ranking-trade-money">{{ item.TotalAmount }}</span>
            <span @click="goCustmerDetail(item.CustomerId)" class="a_href">交易记录</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      List: [],
    };
  },
  computed: {},
  created() {
    this.getRankingData();
  },
  methods: {
    getRankingData() {
      this.$ajax.post("/api/Order/GetTransactionRankingList", {}).then((res) => {
        this.List = res.List;
      });
    },
    goCustmerDetail(id) {
      this.$router.push("/customer/cusDetails?Id=" + id);
    },
  },
};
</script>
<style lang="scss" scoped>
.ranking-container {
  padding: 15px 15px 15px 15px;
  background-color: #fff;
}
.ranking-header {
  width: 100%;
  height: 35px;
}
.ranking-title {
  float: left;
  font-size: 16px;
  color: #333333;
  font-weight: bold;
}
.ranking-body {
  .dz-scroll-y {
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 8px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 8px;
      height: 50px;
      background: #eee;
    }
    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 8px;
      background: rgba(0, 0, 0, 0.4);
    }
  }
  .list-wrap {
    height: 250px;
    padding-right: 20px;
    .list {
      padding: 5px 0;
      height: 30px;
      p {
        vertical-align: middle;
        .ranking-num {
          vertical-align: middle;
          display: inline-block;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: #000;
          color: #fff;
          margin-right: 15px;
          text-align: center;
          line-height: 20px;
        }
        .ranking-name {
          vertical-align: middle;
          display: inline-block;
          width: 35%;
          // height: 30px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .ranking-trade-money {
          vertical-align: middle;
          display: inline-block;
          min-width: 100px;
          text-align: center;
        }
        .a_href {
          float: right;
          cursor: pointer;
          vertical-align: middle;
          color: rgb(16, 142, 233);
        }
      }
    }
  }
}
</style>
